import type { NextPage } from 'next';

import { HomeContainer } from '../routes/home';

const Home: NextPage = () => {
  return <HomeContainer />;
};

export default Home;
